import React, { useState } from 'react';
import './add-service-app-details.css';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import { Button } from 'reactstrap';

const AddServiceAppDetails = ({ handleClose, notify }) => {
  const [formData, setFormData] = useState({
    clientId: '',
    clientSecret: '',
    accessToken: '',
    refreshToken: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const updateFirstServiceToken = async (newData) => {
    try {
      const querySnapshot = await db
        .collection('MeetingToken')
        .where('type', '==', 'service')
        .limit(1) // Fetch only the first document
        .get();

      if (querySnapshot.empty) {
        console.log('No document found with type == service');
        return;
      }

      const doc = querySnapshot.docs[0];
      const docId = doc.id;

      // Update the document
      await db.collection('MeetingToken').doc(docId).update({
        accessToken: newData.accessToken,
        clientSecret: newData.clientSecret,
        refreshToken: newData.refreshToken,
        clientId: newData.clientId,
      });
      setIsSubmitting(false);
      handleClose();
      notify('Details Added Successfully', false);
    } catch (error) {
      setIsSubmitting(false);

      notify(error?.message, true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    updateFirstServiceToken(formData);
  };

  return (
    <div className='add-service-app-details-container'>
      <form
        onSubmit={handleSubmit}
        className='add-service-app-details-form-box'
      >
        <h2 className='add-service-app-details-form-title'>
          Add Service App Details
        </h2>
        {[
          { label: 'Client ID', name: 'clientId' },
          { label: 'Client Secret', name: 'clientSecret' },
          { label: 'Access Token', name: 'accessToken' },
          { label: 'Refresh Token', name: 'refreshToken' },
        ].map(({ label, name }) => (
          <div key={name} className='add-service-app-details-form-group'>
            <label className='add-service-app-details-form-label'>
              {label}
            </label>
            <input
              type='text'
              name={name}
              value={formData[name]}
              onChange={handleChange}
              required
              className='add-service-app-details-form-input'
            />
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button disabled={isSubmitting} onClick={handleClose} type='button'>
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            type='submit'
            className='add-service-app-details-form-button'
          >
            {isSubmitting ? 'Adding...' : ' Submit'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddServiceAppDetails;
